import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { showModal, hideModal } from 'appSrc/redux/actions';
import ShareEmailModal from './Modal';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class EmailShare extends PureComponent {
    constructor(props) {
        super(props);
    }
    share = ( values ) => {
        if( this.props.trackShare ) {
            this.props.trackShare( 'email' );
        }
        var emailData = {
            url: this.props.url,
            emailAddress: values.emailAddress,
            message: values.message || this.props.message,
            subject: this.props.subject,
            image: this.props.image,
            title: this.props.title,
            userLink: `${ process.env.REACT_APP_HOST }/${ this.props.self.slug }`,
        };
        return this.props.sendEmail( emailData );

        // // Old version of email sharing
        // var width  = 575,
        // height = 600,
        // left   = (window.innerWidth - width)  / 2,
        // top    = (window.innerHeight - height) / 2,
        // url    = `mailto:?subject=${ this.props.subject }&body=${ message }`,
        // opts   = `status=1,width=${ width },height=${ height },top=${ top },left=${ left }`;
        //
        // window.open(url, 'mail', opts);
        //
    }
    render() {
        return (
            <div
            className={ style.shareIcon }
            style={ this.props.style }
            onClick={ this.props.showModal }>
                <Icon source='fontAwesome' icon='fas/faEnvelope' alt='Email Share' size={ null } />
                <ShareEmailModal
                closeModal={ this.props.hideModal }
                submitHandler={ this.share }/>
            </div>
        );
    }
}
EmailShare.defaultProps = {
    message: 'would like to share something they found on DesireList.',
    subject: 'Check out my latest find on DesireList',
    url: null,
    image: null,
    title: null,
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        sendEmail: ( data ) => {
            return dAPI.post( '/share/email', data );
            
        },
        showModal: () => {
            dispatch( showModal( 'shareEmailModal' ) );
        },
        hideModal: () => {
            dispatch( hideModal( 'shareEmailModal' ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( EmailShare );
